/* Approved scenic Bitcoin fallback artwork (Figma 215:2-69, 220:63, 222:16).
   Faithful vector reproduction of the approved art direction — used ONLY when
   no eligible live article media exists. */
const SPARKS: [number, number][] = [
  [290, 105], [337, 134], [384, 163], [431, 192], [478, 221], [525, 250], [572, 114], [619, 143],
  [306, 172], [353, 201], [400, 230], [447, 259], [494, 123], [541, 152], [588, 181], [635, 210],
  [322, 239], [369, 268], [416, 132], [463, 161], [510, 190], [557, 219], [604, 248], [291, 112],
  [338, 141], [385, 170], [432, 199], [479, 228], [526, 257], [573, 121], [620, 150], [307, 179],
  [354, 208], [401, 237], [448, 266], [495, 130], [542, 159], [589, 188], [636, 217], [323, 246],
  [370, 110], [417, 139],
];
const LINE_PTS: [number, number][] = [[280, 205], [350, 215], [420, 178], [490, 145], [570, 120], [650, 93], [735, 66]];

export const ScenicBtcArt = () => (
  <svg viewBox="0 0 760 395" preserveAspectRatio="xMidYMid slice" className="w-full h-full block" aria-hidden>
    <defs>
      <linearGradient id="h3sky" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#03050b" /><stop offset="0.48" stopColor="#1c0719" />
        <stop offset="0.72" stopColor="#561e08" /><stop offset="1" stopColor="#030507" />
      </linearGradient>
      <radialGradient id="h3sun" cx="0.5" cy="0.5" r="0.5">
        <stop offset="0" stopColor="#ff770c" stopOpacity="0.75" />
        <stop offset="0.35" stopColor="#f23305" stopOpacity="0.24" />
        <stop offset="1" stopColor="#33071e" stopOpacity="0" />
      </radialGradient>
      <radialGradient id="h3coin" cx="0.42" cy="0.35" r="0.75">
        <stop offset="0" stopColor="#ffaf1e" /><stop offset="0.6" stopColor="#f25905" />
        <stop offset="1" stopColor="#541602" />
      </radialGradient>
      <linearGradient id="h3ground" x1="0" y1="0" x2="0" y2="1">
        <stop offset="0" stopColor="#050607" stopOpacity="0" /><stop offset="1" stopColor="#020304" />
      </linearGradient>
    </defs>
    <rect width="760" height="395" fill="url(#h3sky)" />
    <circle cx="450" cy="235" r="130" fill="url(#h3sun)" />
    <path d="M300,395 L372,242 L442,300 L522,206 L612,290 L682,236 L760,322 L760,395 Z" fill="#11131a" />
    {SPARKS.map(([x, y], i) => (
      <circle key={i} cx={x} cy={y} r={0.6 + (i % 3) * 0.55}
        fill={i % 2 ? "#ffd06a" : "#ff7b1a"} opacity={0.45 + (i % 4) * 0.12} />
    ))}
    <polyline points={LINE_PTS.map((p) => p.join(",")).join(" ")} fill="none" stroke="#b23dff" strokeWidth="3"
      strokeLinejoin="round" strokeLinecap="round" />
    {LINE_PTS.map(([x, y], i) => (
      <g key={i}>
        <line x1={x} y1={y - 20} x2={x} y2={y + 20} stroke={i % 2 ? "#d13cff" : "#18d5f3"} strokeWidth="2" opacity="0.75" />
        <circle cx={x} cy={y} r="2.5" fill="#e44dff" />
      </g>
    ))}
    <g>
      <circle cx="580" cy="240" r="95" fill="url(#h3coin)" stroke="#ffb22a" strokeWidth="3" />
      <circle cx="580" cy="240" r="85.5" fill="none" stroke="#ffcc59" strokeOpacity="0.65" strokeWidth="1.5" />
      <circle cx="580" cy="240" r="79.5" fill="none" stroke="#6f2302" strokeOpacity="0.6" strokeWidth="1" />
      <circle cx="580" cy="240" r="77" fill="#9a3b05" fillOpacity="0.35" stroke="#ffd36a" strokeWidth="2" />
      <text x="580" y="243" textAnchor="middle" dominantBaseline="middle"
        fontSize="92" fontWeight="700" fill="#ffd65b" fontFamily="Inter, sans-serif">₿</text>
    </g>
    <path d="M250,395 L332,282 L402,340 L472,256 L562,330 L642,286 L760,362 L760,395 Z" fill="#080a0e" />
    <rect y="290" width="760" height="105" fill="url(#h3ground)" />
  </svg>
);
